import { Stack } from 'expo-router';
import React from 'react';

function ProgressTrackerFundingScreen() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default ProgressTrackerFundingScreen;
